import { gql } from '@apollo/client';

const CASE_WITH_APPOINTMENTS = `
  id
  appointments {
    id
    clientTempId
    date
    time
    notes
    description
    followUpAppointment
    walkIn
    status
    practitioner {
      id
      firstName
      lastName
    }
    consultationTypes {
      id
      name
    }
    consultation {
      id
    }
    categories {
      id
      name
    }
  }
`;

// Persist a single appointment against an existing case (appointment modal Save).
export const UPSERT_CASE_APPOINTMENT = gql`
  mutation upsertCaseAppointment($caseId: ID!, $input: UpsertCaseAppointmentInput!) {
    case: upsertCaseAppointment(caseId: $caseId, input: $input) {
      ${CASE_WITH_APPOINTMENTS}
    }
  }
`;

// Delete a single appointment (case-level Cancel cleanup for rows added this session).
export const DELETE_CASE_APPOINTMENT = gql`
  mutation deleteCaseAppointment($id: ID!) {
    case: deleteCaseAppointment(id: $id) {
      ${CASE_WITH_APPOINTMENTS}
    }
  }
`;
